/* 全局安装的第三方插件 */
import Vue from 'vue'

import './element'
// import './sensors'
import './geetest'

// 懒加载
import VueLazyload from 'vue-lazyload'

Vue.use(VueLazyload, {
  attempt: 1
})
